import { render, staticRenderFns } from "./centerLeft2.vue?vue&type=template&id=0d897d6b"
import script from "./centerLeft2.vue?vue&type=script&lang=js"
export * from "./centerLeft2.vue?vue&type=script&lang=js"
import style0 from "./centerLeft2.vue?vue&type=style&index=0&id=0d897d6b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports